<body>
  <div class="hamburger hamburger--spin" [ngClass]="isMenuOpen ? 'is-active' : ''" (click)="toggleCollapse()" (keydown)="toggleCollapse();">
    <span class="hamburger-box">
      <span class="hamburger-inner"></span>
    </span>
  </div>
  <div *ngIf="isLoading" class="svg-loader"></div>
  <app-nav-bar [data]="globals.userEmail"></app-nav-bar>
  <mat-sidenav-container>
    <mat-sidenav [ngClass]="(sidenavWidth > 6)?'horizontalMenu':'verticalMenu'" [disableClose]="true" #sidenav mode="side" class="example-sidenav" [ngStyle]="{ 'width.em': sidenavWidth }" opened="true">
      <mat-nav-list>

        <ng-container *ngIf="this._router.url.includes('Flowsheet') || this._router.url.includes('flowsheetBuilder')">
          <div class="menu menu-sm" routerLink="Flowsheet" [ngClass]="{'isActive': isActive('Flowsheet')}">
            <div class="centered single-line">Flowsheet</div>
          </div>
          <div class="menu menu-sm" routerLink="flowsheetBuilder" [ngClass]="{'isActive': isActive('flowsheetBuilder')}">
            <div class="centered single-line">Builder</div>
          </div>
        </ng-container>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content [ngClass]="(sidenavWidth > 6)?'collapsedMatSidenavContent':'non-collapsedMatSidenavContent'">
      <main>
        <router-outlet></router-outlet>
      </main>
    </mat-sidenav-content>


  </mat-sidenav-container>

</body>
